// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tOJhDW7XvOMx1ah0tc1M {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.tOJhDW7XvOMx1ah0tc1M label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  margin-bottom: 8px;
}

.tOJhDW7XvOMx1ah0tc1M input {
  height: 42px;
  border-radius: 5px;
  padding: 8px;
  box-sizing: border-box;
  color: black;
}

.aFdR2tkbJNUdxPtMQpjA p {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
  font-size: 12px;
  margin-top: 4px;
}

.f8p75BK5tqMgdWr8_fYY input {
  border-color: red;
}

.gwYxPJLkkseMjLDyNBMO input {
  background-color: #C4C4C4;
  outline: none;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/library/Input/CountryDropdown/CountryDropdown.module.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mDAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value color-error, color-gray-light from colors;\n\n.country {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n}\n\n.country label {\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.country input {\n  height: 42px;\n  border-radius: 5px;\n  padding: 8px;\n  box-sizing: border-box;\n  color: black;\n}\n\n.hint p {\n  color: color-error;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.error input {\n  border-color: red;\n}\n\n.disabled input {\n  background-color: #C4C4C4;\n  outline: none;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"country": `tOJhDW7XvOMx1ah0tc1M`,
	"hint": `aFdR2tkbJNUdxPtMQpjA`,
	"error": `f8p75BK5tqMgdWr8_fYY`,
	"disabled": `gwYxPJLkkseMjLDyNBMO`
};
export default ___CSS_LOADER_EXPORT___;
